export class TokenBucket {
  // Current number of tokens (float).
  private tokens: number;
  // Total bucket capacity.
  private capacity: number;
  // Number of tokens refilled in 1 second. Defaults to capacity.
  private fillTokensPerSecond: number;
  /**
   * The last time refilled in milliseconds.
   * https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp
   */
  private lastFilled: number | null = null;

  constructor(capacity: number, fillTokensPerSecond?: number) {
    this.capacity = capacity;
    if (fillTokensPerSecond === undefined) {
      this.fillTokensPerSecond = capacity;
    } else {
      this.fillTokensPerSecond = fillTokensPerSecond;
    }
    // The bucket starts out filled.
    this.tokens = capacity;
  }

  private static getTimeMs(): number {
    return window.performance.now();
  }

  // Refills tokens according to the fillRate.
  private refill() {
    if (this.lastFilled !== null) {
      const elapsedMs = TokenBucket.getTimeMs() - this.lastFilled;
      const tokensToAdd = (elapsedMs / 1000) * this.fillTokensPerSecond;
      this.tokens = Math.min(this.tokens + tokensToAdd, this.capacity);
    }
    this.lastFilled = TokenBucket.getTimeMs();
  }

  /**
   * If the bucket has enough tokens, removes the specified number
   * and returns true. Otherwise returns false.
   */
  removeToken(tokensToRemove: number = 1): boolean {
    this.refill();
    if (this.tokens >= tokensToRemove) {
      this.tokens -= tokensToRemove;
      return true;
    }
    return false;
  }

  // Number of whole tokens.
  get numTokens(): number {
    this.refill();
    return Math.floor(this.tokens);
  }
}
